module.exports = __webpack_public_path__ + "f01ba5616e76db8305af88a444893690.jpg";